
import { Card } from "@/components/ui/card";

interface ErrorDisplayProps {
  message: string;
}

export const ErrorDisplay = ({ message }: ErrorDisplayProps) => {
  return (
    <div className="flex items-center justify-center h-[calc(100vh-4rem)]">
      <Card className="p-6">
        <h2 className="text-lg font-semibold text-destructive mb-2">Error Loading Teams</h2>
        <p className="text-gray-500">Please check your permissions or try again later.</p>
        <p className="text-sm text-gray-400 mt-2">{message}</p>
      </Card>
    </div>
  );
};
